module.exports = __webpack_public_path__ + "media/assets/images/bg-release-selected-7769d231626383dea1094a9a6f56666e.jpg";